
// 引用axios
var axios = require('axios');
import { Notification, MessageBox, Message } from 'element-ui'
function apiAxios (method, url, params, success, failure) {
  let CancelToken = axios.CancelToken;
   //去除对象内多余的空值key
  // for (let key in params) {              
  //     if (params[key] == '') {
  //       delete params[key];
  //     }
  // }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    withCredentials: false,
    cancelToken: new CancelToken(function executor(c) {
      window.Vue.cancel = c
      // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
    })
  })
  .then(function (res) {
    success(res.data)
  })
  .catch(function (err) {
    if (err) {
      failure && failure(err)
      // window.alert('error: ' + res)
    }
  })
}

axios.interceptors.request.use(
  config => {
    if (window.Vue.$common.getCookie('tibiot-company-card-web')) {
      // 每次发请求，请求头带token
      config.headers.Authorization = window.Vue.$common.getCookie('tibiot-company-card-web');
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

  // 错误提示
  axios.interceptors.response.use(
    response => {
      switch (response.data.code) {
        case 401:
          document.cookie='tibiot-company-card-web='+ window.Vue.$common.getCookie('tibiot-company-card-web') + ';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT'; // 退出清除token cookie
          window.localStorage.removeItem("vuex-along");//清除vue-along
          window.Vue.$router.push("/login");
          // MessageBox.confirm(
          //   response.data.message,
          //   '系统提示',
          //   {
          //     confirmButtonText: '重新登录',
          //     showCancelButton:false,
          //     type: 'warning'
          //   }
          // ).then(() => {  
            
          // })
          break;
      }
      return response;
    },
    error => {
      console.log('err' + error)
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error.response.data)
    });

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  }
}



// WEBPACK FOOTER //
// ./src/axios_api/index.js